import { useCallback } from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { AccountDropdown } from 'modules/campaigns/modules/common-campaign-form';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import styles from './subscriptionAccountField.module.scss';

export const SubscriptionAccountField = () => {
    const { formAccount, setFormAccount } = useFormDataContext();
    const onAccountChange = useCallback(
        value => {
            setFormAccount(value);
        },
        [setFormAccount]
    );
    return (
        <FormField containerClass={styles['account-field']}>
            <AccountDropdown
                onAccountChange={onAccountChange}
                accountForCampaign={formAccount}
                skipFormResetOnAccountChange
            />
        </FormField>
    );
};
